<template>
	<div>
		<TilteParallax>
			<template v-slot:title>
				Artículos
			</template>

			<template v-slot:menu>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							fab
							elevation="5"
							:loading="ui.loading"
							color="default"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon>
								mdi-dots-vertical
							</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item @click="exportToCSV()">
							<v-list-item-title>
								Exportar
							</v-list-item-title>
						</v-list-item>

						<v-list-item @click="articleImport()">
							<v-list-item-title>
								Importar
							</v-list-item-title>
						</v-list-item>

						<v-list-item @click="nonExistenceExport()">
							<v-list-item-title>
								Exportar inexistentes
							</v-list-item-title>
						</v-list-item>

						<v-list-item @click="unusableExport()">
							<v-list-item-title>
								Exportar inutilizables
							</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</template>

			<template v-slot:subtitle>
				{{ `Artículos: ${data.articles.length}` }}
			</template>
		</TilteParallax>

		<v-container fluid>
			<v-row justify="center" class="pt-0 mt-0">
				<v-col cols="12" md="10">
					<v-card outlined :loading="ui.geting">
						<v-card-text>
							<v-row>
								<v-col cols="12" class="pb-0">
									<v-text-field
										dense
										outlined
										label="Críterio de busqueda"
										v-model="ui.filters.criterium"
										clearable
									></v-text-field>
								</v-col>
								<v-col cols="12" class="pt-0">
									<v-data-table
										:search="ui.filters.criterium"
										:headers="headers"
										:items="data.articles"
									>
										<!-- Price List Slot -->
										<template
											v-slot:item.price_list="{ item }"
										>
											<router-link
												v-if="item.price_list"
												:to="{
													name: 'PriceListShow',
													params: {
														id: item.price_list.id,
													},
												}"
											>
												{{ item.price_list.name }}
											</router-link>
										</template>

										<!-- Slot Special -->
										<template
											v-slot:item.special="{ item }"
										>
											<v-chip
												small
												color="primary"
												v-if="item.special"
											>
												Especial
											</v-chip>
										</template>

										<!-- Slot Actions -->
										<template
											v-slot:item.actions="{ item }"
										>
											<v-btn
												color="primary"
												text
												@click="show(item)"
											>
												Ver
											</v-btn>
										</template>
									</v-data-table>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<!-- Article Import -->
		<Import></Import>
	</div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { EventBus } from "@/main";
import { mapGetters } from "vuex";

// Components
import Import from "@/components/Article/Import";
import TilteParallax from "@/components/TilteParallax";

// Class
import Csv from "@/../../GeneralComponents/Class/Csv";

export default {
	components: { TilteParallax, Import },

	data() {
		return {
			headers: [
				{ text: "id", value: "id" },
				{ text: "Codigo", value: "code" },
				{ text: "Descripción", value: "description" },
				{ text: "Producto", value: "product.name" },
				{ text: "Acabado", value: "type_of_finish.name" },
				{ text: "Precio base", value: "base_price" },
				{ text: "Descuento base(%)", value: "base_discount" },
				{ text: "Contenido neto", value: "contents" },
				{ text: "UM", value: "unit_of_measurement.name" },
				{ text: "Peso", value: "weight" },
				{ text: "Capacidad por caja", value: "box_capacity" },
				{ text: "Especial", value: "special" },

				// { text: "Acciones", value: "actions" },
			],

			data: {
				articles: [],
			},

			ui: {
				geting: true,

				loading: false,

				filters: {
					criterium: null,
				},
			},
		};
	},

	created() {
		this.get();

		if (this.$route.query.criterium) {
			this.ui.filters.criterium = this.$route.query.criterium;
		}

		EventBus.$on("ArticleIndex", () => {
			this.get();
		});
	},

	methods: {
		async get() {
			try {
				this.ui.geting = true;

				let resp = await axios.get(
					`${process.env.VUE_APP_API_SERVER}/auth/store/article/all/withtrashed`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.state.acount.token}`,
						},
					}
				);

				this.data.articles = resp.data.data;
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.geting = false;
			}
		},

		async exportToCSV() {
			try {
				this.ui.loading = true;

				let csv = new Csv(this.data.articles);

				await csv.toCsv({
					name: "articles",
				});

				csv.csvDownload();
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.loading = false;
			}
		},

		async nonExistenceExport() {
			try {
				this.ui.loading = true;

				let response = await axios.get(
					`${process.env.VUE_APP_API_SERVER}/auth/store/article/nonexistence`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.state.acount.token}`,
						},
					}
				);

				let csv = new Csv({ id: response.data.data });

				await csv.toCsv({
					name: "none_xistence",
					mapType: "vertical",
				});

				csv.csvDownload();
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.loading = false;
			}
		},

		async unusableExport() {
			try {
				this.ui.loading = true;

				let response = await axios.get(
					`${process.env.VUE_APP_API_SERVER}/auth/store/article/unusable`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.state.acount.token}`,
						},
					}
				);

				let csv = new Csv({ id: response.data.data });

				await csv.toCsv({
					name: "unusable",
					mapType: "vertical",
				});

				csv.csvDownload();
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.loading = false;
			}
		},

		articleImport() {
			EventBus.$emit("ArticleImport");
		},

		show(article) {
			EventBus.$emit("ArticleShow", article);
		},
	},

	computed: {
		...mapState(["acount"]),

		...mapGetters(["getArticles"]),
	},
};
</script>

<style lang="css" scoped></style>
